import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import {
  Activity,
  Airplay,
  AlertCircle,
  AlertTriangle,
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Anchor,
  Aperture,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  AtSign,
  Award,
  Bookmark,
  Box,
  Briefcase,
  Calendar,
  Camera,
  Check,
  ChevronDown,
  Clock
} from 'lucide-react';

const icons = [
  { name: 'Activity', component: Activity },
  { name: 'Airplay', component: Airplay },
  { name: 'AlertCircle', component: AlertCircle },
  { name: 'AlertTriangle', component: AlertTriangle },
  { name: 'AlignCenter', component: AlignCenter },
  { name: 'AlignJustify', component: AlignJustify },
  { name: 'AlignLeft', component: AlignLeft },
  { name: 'AlignRight', component: AlignRight },
  { name: 'Anchor', component: Anchor },
  { name: 'Aperture', component: Aperture },
  { name: 'Archive', component: Archive },
  { name: 'ArrowDown', component: ArrowDown },
  { name: 'ArrowLeft', component: ArrowLeft },
  { name: 'ArrowRight', component: ArrowRight },
  { name: 'ArrowUp', component: ArrowUp },
  { name: 'AtSign', component: AtSign },
  { name: 'Award', component: Award },
  { name: 'Bookmark', component: Bookmark },
  { name: 'Box', component: Box },
  { name: 'Briefcase', component: Briefcase },
  { name: 'Calendar', component: Calendar },
  { name: 'Camera', component: Camera },
  { name: 'Check', component: Check },
  { name: 'ChevronDown', component: ChevronDown },
  { name: 'Clock', component: Clock }
];

interface IconSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (Icon: any) => void;
}

export const IconSelectionModal: React.FC<IconSelectionModalProps> = ({
  open,
  onClose,
  onSelect
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Select an Icon</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-5 gap-4 p-4">
          {icons.map(({ name, component: Icon }) => (
            <button
              key={name}
              onClick={() => {
                onSelect(Icon);
                onClose();
              }}
              className="flex flex-col items-center gap-2 p-4 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Icon size={24} />
              <span className="text-sm text-gray-600">{name}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
